import { render, staticRenderFns } from "./gitComponent.vue?vue&type=template&id=7485344f&scoped=true&"
import script from "./gitComponent.vue?vue&type=script&lang=js&"
export * from "./gitComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485344f",
  null
  
)

export default component.exports